import NetxQueryClient from '@netx/core-next/lib/queryClient';

import type {BatchJobId as UUID} from '@netx/core-app/models/batchJob';

/**
 * `setProgressReportNotify` request params
 * (what is used to send to server)
 */
export interface SetProgressReportNotifyRequestOptions {
	uuid: UUID;
	notify: boolean;
}

/**
 * `setProgressReportNotify` request
 * (what gets sent to the server)
 */
export type SetProgressReportNotifyRequest = [
	SetProgressReportNotifyRequestOptions['uuid'],
	SetProgressReportNotifyRequestOptions['notify'],
];

/**
 * `setProgressReportNotify` response
 * (what comes back from the server)
 */
export interface SetProgressReportNotifyResponse {
	result: SetProgressReportNotifyResult;
}

/**
 * `setProgressReportNotify` result
 * (what is utilized from the server response)
 */
export type SetProgressReportNotifyResult = boolean;

export const setProgressReportNotifyEndpoint = 'setProgressReportNotify';

/**
 * Notify when done
 * @param fetchParams Fetch params
 */
export const setProgressReportNotify = async (
	{uuid, notify}: SetProgressReportNotifyRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: SetProgressReportNotifyRequest = [uuid, notify];

	return client
		.post<SetProgressReportNotifyResponse>(
			setProgressReportNotifyEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default setProgressReportNotify;
